module.exports = __webpack_public_path__ + "static/lendit-e16b4d13a69797f87d5fdc87cd488a27.jpg";